module.exports = __webpack_public_path__ + "img/frame3.b772c153.png";